export default {
    url: '/courses',
    template: '<materials-trainings/>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/materials/trainings/index.js